export const getLinkUrl = (url: string) =>
  url.includes("http") ? url : `//${url}`;
